// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_g5-3";
export var flatBottomCorners = "_g5-5";
export var productImage = "_g5-0";
export var quantityContainer = "_g5-2";
export var quantityHeader = "_g5-6";
export var tooltip = "_g5-1";
export var wrapAndEllipsesOverflow = "_g5-4";